/**
 * This type represents the boolean type in ABAP.
 */
export enum ABAPBoolean {
  true = "X",
  false = "",
}
